module.exports = __webpack_public_path__ + "img/events_5.b27a64a7.jpg";